module.exports = __webpack_public_path__ + "media/images/favicon-d55b6901b956fe9f604ab22e57db30f0.png";